<template>
    <modal @close="emit('close')">
        <div class="w-[300px]">
            <div class="text-xl px-3 mb-4">{{ title }}</div>
            <div class="flex justify-between px-3"
                 :class="{ 'pointer-events-none opacity-70': readonly }">
                <div>
                    <div class="text-xs text-gray pb-1">Дата начала</div>
                    <AppDateInput mode="single" :model-value="dateFrom" @update:model-value="dateFrom = $event as Dayjs" />
                </div>
                <div>
                    <div class="text-xs text-gray pb-1">Дата окончания</div>
                    <AppDateInput mode="single" :model-value="dateTo" @update:model-value="dateTo = $event as Dayjs" />
                </div>
            </div>
            <div v-if="isConsolidated" class="mt-4 space-y-3 px-3">
                <div class="grid grid-cols-[1fr_auto_1fr] items-center gap-2">
                    <span class="text-xs text-gray">ФИО</span>
                    <BooleanSwitch v-model="isGroupedByPosition" class="!gap-0" :disabled="readonly" />
                    <span class="text-right text-xs text-gray">Должность</span>
                </div>
                <div class="grid grid-cols-[1fr_auto_1fr] items-center gap-2">
                    <span class="text-xs text-gray">Штат</span>
                    <BooleanSwitch v-model="isOutsource" class="!gap-0" :disabled="readonly" />
                    <span class="text-right text-xs text-gray">Штат + аутсорс</span>
                </div>
            </div>
            <div class="flex justify-between px-3 mt-10">
                <btn type="secondary" class="px-5" @click="emit('close')">Отмена</btn>
                <btn class="px-5" :disabled="isLoading" :class="{ 'opacity-50': isLoading }" @click="download">Скачать</btn>
            </div>
        </div>
    </modal>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import dayjs from 'dayjs'
import type { Dayjs } from 'dayjs'
import AppDateInput from './AppDateInput.vue'
import BooleanSwitch from './BooleanSwitch.vue'
import { useScheduleStore } from '@/stores/scheduleStore'

const props = withDefaults(defineProps<{
    title: string
    reportFn: (data: any) => Promise<any>
    reportName: string
    initialDate?: Dayjs
    readonly?: boolean
    isConsolidated?: boolean
}>(), {
    initialDate: () => dayjs(),
    readonly: false,
    isConsolidated: false,
})

const emit = defineEmits(['close'])

const scheduleStore = useScheduleStore()

const referenceDate = props.initialDate
const dateFrom = ref<Dayjs>(referenceDate.startOf('month'))
const dateTo = ref<Dayjs>(referenceDate.endOf('month'))
const isLoading = ref(false)
const isGroupedByPosition = ref(false)
const isOutsource = ref(false)

async function download() {
    isLoading.value = true
    try {
        const data = {
            department_id: scheduleStore.currentDepartment?.id,
            date_from: dateFrom.value.format('YYYY-MM-DD'),
            date_to: dateTo.value.format('YYYY-MM-DD'),
            ...(props.isConsolidated && {
                group_by: isGroupedByPosition.value ? 'position' : 'employee',
                is_outsource: isOutsource.value,
            }),
        }
        const res = await props.reportFn(data)
        const blob = new Blob([res.data])
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${props.reportName} ${data.date_from}—${data.date_to}.xlsx`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
        emit('close')
    } finally {
        isLoading.value = false
    }
}
</script>
